import React, { useState } from 'react';
import './VideoShowcase.css';
import wisbyLogo from '../../assets/logo.png';

// Componente `PlayIcon` que renderiza esta parte de la interfaz.
const PlayIcon = ({ isPlaying }) => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    {isPlaying ? (
      <>
        <path d="M9 7v10" />
        <path d="M15 7v10" />
      </>
    ) : (
      <path className="video-showcase-play-shape" d="M8.5 6.5 17 12l-8.5 5.5z" />
    )}
  </svg>
);

// Componente `VolumeIcon` que renderiza esta parte de la interfaz.
const VolumeIcon = ({ isMuted }) => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <path d="M5 10v4h3l4 3V7L8 10H5Z" />
    {isMuted ? (
      <>
        <path d="m16 10 4 4" />
        <path d="m20 10-4 4" />
      </>
    ) : (
      <>
        <path d="M16 9.5a4 4 0 0 1 0 5" />
        <path d="M18.5 7a7 7 0 0 1 0 10" />
      </>
    )}
  </svg>
);

// Componente `VideoShowcase` que renderiza esta parte de la interfaz.
export default function VideoShowcase() {
  // Estado local `isPlaying` y su actualizador, usados para reflejar cambios en la interfaz.
  const [isPlaying, setIsPlaying] = useState(false);
  // Estado local `isMuted` y su actualizador, usados para reflejar cambios en la interfaz.
  const [isMuted, setIsMuted] = useState(false);

  return (
    <section className="video-showcase-section" aria-label="Presentación de Wisby">
      <div className={`video-showcase-card${isPlaying ? ' is-playing' : ''}`}>
        <div className="video-showcase-light video-showcase-light--two" aria-hidden="true" />

        <img className="video-showcase-logo" src={wisbyLogo} alt="Wisby" />

        <div className="video-showcase-controls" aria-label="Controles de la presentación">
          <button
            type="button"
            className="video-showcase-control"
            onClick={() => setIsPlaying((playing) => !playing)}
            aria-label={isPlaying ? 'Pausar presentación' : 'Reproducir presentación'}
            title={isPlaying ? 'Pausar' : 'Reproducir'}
          >
            <PlayIcon isPlaying={isPlaying} />
          </button>
          <button
            type="button"
            className="video-showcase-control"
            onClick={() => setIsMuted((muted) => !muted)}
            aria-label={isMuted ? 'Activar sonido' : 'Silenciar presentación'}
            aria-pressed={isMuted}
            title={isMuted ? 'Activar sonido' : 'Silenciar'}
          >
            <VolumeIcon isMuted={isMuted} />
          </button>
        </div>
      </div>
    </section>
  );
}
